// @flow
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { IconArrowBigLeft } from '../icons/IconArrow'
import * as text from '../text'

type Props = {
  children: React.Node,
  logoWidth: [string, string],
  onClose: () => void,
}

const ExpandedMenu = ({ children, logoWidth, onClose }: Props) => {
  const [open, setOpen] = React.useState(!!children)

  React.useEffect(() => {
    setOpen(!!children)
  }, [children])

  return (
    <Root open={open} logoWidth={logoWidth}>
      <StyledMenu open={open}>
        <StyledGoBack
          tabIndex={0}
          role="button"
          onClick={() => {
            onClose()
            setOpen(false)
          }}
        >
          <IconArrowBigLeft color={colors.darkPurple} />
          <span>Back</span>
        </StyledGoBack>
        <ContentWrapper>{children}</ContentWrapper>
      </StyledMenu>
    </Root>
  )
}

const openCss = css`
  height: 420px;
  max-height: 420px;
`

const Root = styled<{
  children: React.Node,
  logoWidth: [string, string],
  open: boolean,
}>('div')`
  width: 100%;
  position: absolute;
  background: ${(p) => p.theme.background};
  padding-left: 20px;
  padding-right: 20px;
  transition: all 200ms ease;
  overflow: hidden;

  ${media.mq[1]} {
    background: ${(p) => p.theme.backgroundDesktop};
    height: 0;
    ${(p) => (p.open ? openCss : '')}
  }

  ${media.mq[2]} {
    padding-left: calc(20px + ${(p) => p.logoWidth[1]} + 30px);
  }
`

const StyledGoBack = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
  cursor: pointer;

  & > span {
    margin-left: 20px;
    ${text.paragraph3};
    color: ${colors.darkPurple};
  }

  svg {
    width: 30px;
  }

  ${media.mq[1]} {
    display: none;
  }
`

const StyledMenu = styled.div`
  flex-direction: column;
  display: ${(p) => (p.open ? 'flex' : 'none')};

  ${media.mq[1]} {
    display: ${({ open }) => (open ? 'block' : 'none')};
    max-width: 1200px;
  }
`

const ContentWrapper = styled.div`
  padding-top: 27px;

  min-height: calc(100vh - 64px);

  ${media.mq[1]} {
    padding-top: 8px;
    min-height: inherit;
  }
`

export default ExpandedMenu
